module.exports = __webpack_public_path__ + "img/home_logo.b49c466e.png";